// extracted by mini-css-extract-plugin
module.exports = {"brandSecondary":"#4d2079","sessionsCard":"style-module__sessionsCard___2-G9n","title":"style-module__title___hRo8g","headline":"style-module__headline___1wSKd"};